import React, { useState, useEffect, useCallback } from "react";
import * as moment from "moment";
import { Modal } from "../../../../modals/modal";
import { RightCardModalContent } from "../../../../modals/modal";
import NotificationContent from "./NotificationContent";
import notificationIcon from "../../../../Assets/notification-icon.svg";
import noNotificationIcon from "../../../../Assets/no-notification-icon.svg";

import "./notification.css";
import { $api } from "../../../../../helpers/$api";
import { toast } from "react-toastify";

const Notification = ({ show, onCloseClick, refresh }) => {
  const [notifications, setNotifications] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      const notifications = await $api.user.getUnreadNotifications();

      setNotifications(Array.isArray(notifications) ? notifications : []);
    } catch (error) {
      // error getting notifications...
    }
  }, [setNotifications]);

  const handleReadAllClick = async () => {
    try {
      await $api.user.markAllNotificationsRead();
      fetchData();
      refresh();
    } catch (error) {
      toast.error(`could not mark notifications as read`);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <Modal show={show} onCloseClick={onCloseClick}>
        <RightCardModalContent onBackClick={onCloseClick}>
          <div className="notification-container">
            <div className="notification-head">
              <h2>Notification</h2>
              <p
                style={{
                  cursor: "pointer",
                }}
                onClick={handleReadAllClick}
              >
                Read all
              </p>
            </div>
            {notifications.length ? (
              <div>
                {notifications.map((notification) => {
                  return (
                    <NotificationContent
                      icon={notificationIcon}
                      message={notification.data.notification}
                      time={moment(notification.created_at).fromNow()}
                      key={notification.id}
                    />
                  );
                })}

                {/* <NotificationContent
                  icon={notificationIcon}
                  message="Your transfer to @Adeola has been processed successfully."
                  time="6 days ago"
                />
                <NotificationContent
                  icon={notificationIcon}
                  message="A new card 2344 2345 **** 2345 was successfully added. Refer your friends to get bonus credits"
                  time="6 days ago"
                />
                <NotificationContent
                  icon={notificationIcon}
                  message="Your means of identification has been approved"
                  time="6 days ago"
                  btn={<button>Approved</button>}
                /> */}
              </div>
            ) : (
              <div className="no-notification">
                <img src={noNotificationIcon} alt="no-notification" />
                <p> You have no notifications </p>
              </div>
            )}
          </div>
        </RightCardModalContent>
      </Modal>
    </>
  );
};

export default Notification;
